import { Honeybadger } from '@honeybadger-io/react'

Honeybadger.configure({
    apiKey: process.env.NEXT_PUBLIC_HONEYBADGER_API_KEY,
    environment: process.env.NODE_ENV === 'production' ? (process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview' ? 'staging' : 'production') : 'development',
    revision: process.env.NEXT_PUBLIC_HONEYBADGER_REVISION || process.env.VERCEL_GIT_COMMIT_SHA || Date.now().toString(),
    projectRoot: 'webpack://_N_E/./',
    developmentEnvironments: ['dev', 'development', 'test'],
    reportData: process.env.NODE_ENV === 'production',
    // debug: true,
}).beforeNotify((notice) => {
    if (!notice) {
        return
    }
    if (notice.name === 'window.onunhandledrejection') return false;

    const ignoredMessages = [
        "Couldn't find Invoice",
        "ResizeObserver loop limit exceeded",
        "ResizeObserver loop completed with undelivered notifications.",
        "Failed to load chunk",
        "Loading chunk",
        "reading 'getBoundingClientRect'",
        "Minified React error #418",
        "Minified React error #423",
        // Browser extensions (crypto wallets, Grammarly, etc.) monkeypatch
        // appendChild and JSON.stringify DOM nodes, hitting React fibers. This
        // is thrown from injected code inside React's commit phase, so our
        // _next/ react-dom frames are in the stack and defeat the injected-
        // script heuristic below. Not our bug; drop by message.
        "Converting circular structure to JSON",
    ];
    if (notice.message && ignoredMessages.some(msg => notice.message.includes(msg))) return false;
    if (['Error', 'window.onerror'].includes(notice.name) && ignoredMessages.includes(notice.message)) return false;

    // Ignore errors from injected scripts (browser extensions, bots, etc.)
    // These have no stack trace from our app code - just "global code" at line 1
    const backtrace = notice.backtrace || [];
    if (backtrace.length > 0) {
        const hasAppCode = backtrace.some(frame => {
            const file = frame.file || '';
            // Our app code comes from _next/ bundles or webpack
            return file.includes('/_next/') || file.includes('webpack');
        });
        // If no frames from our code, it's likely an injected script
        if (!hasAppCode) return false;
    }
})
Honeybadger.logger.debug('Honeybadger configured for browser')
